import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to ShoNics!");
      nav("/dashboard");
    } catch (e) {
      toast.error("Could not create account", { description: e?.response?.data?.detail || "" });
    } finally { setLoading(false); }
  };

  return (
    <div className="container-x py-20 md:py-28 min-h-[70vh] flex items-center" data-testid="register-page">
      <div className="grid md:grid-cols-2 gap-16 w-full items-center">
        <div className="hidden md:block">
          <div className="overline mb-4">Create account</div>
          <h1 className="font-serif text-5xl tracking-tight text-[#111]">Become a <span className="gold-shimmer-text">ShoNics insider.</span></h1>
          <p className="mt-5 text-[#4A554E]">Members unlock loyalty rewards, faster booking, and exclusive recurring rates.</p>
        </div>
        <form onSubmit={submit} className="card-luxe p-8 md:p-10 max-w-md w-full mx-auto" data-testid="register-form">
          <div className="flex items-center gap-2 mb-6">
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <h2 className="font-serif text-2xl">Create your account</h2>
          </div>
          {[
            { k: "name", label: "Full name", type: "text" },
            { k: "email", label: "Email", type: "email" },
            { k: "phone", label: "Phone", type: "tel" },
            { k: "password", label: "Password (min 6)", type: "password" },
          ].map((f) => (
            <React.Fragment key={f.k}>
              <label className="overline">{f.label}</label>
              <input type={f.type} required={f.k !== "phone"} minLength={f.k === "password" ? 6 : undefined}
                value={form[f.k]} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                className="w-full px-5 py-3.5 mt-2 mb-5 rounded-full border border-[#EAE3D2] focus:border-[#0B5D3B] focus:outline-none"
                data-testid={`register-${f.k}`} />
            </React.Fragment>
          ))}
          <button disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="register-submit">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Creating…</> : "Create account"}
          </button>
          <div className="text-sm text-[#4A554E] mt-5 text-center">
            Already have an account? <Link to="/login" className="text-[#0B5D3B] font-semibold">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
